import Spell from 'common/SPELLS/Spell';

const spells = {
  // Sarkareth
  ASTRAL_FLARE_BUFF: {
    id: 407576,
    name: 'Astral Flare',
    icon: 'sha_ability_mage_firestarter_nightborne',
  },
} satisfies Record<string, Spell>;

export default spells;
